import { SlingoLang } from "@lib/titan2-slingo/dist/game/view/abstract/lang/SlingoLang";
import { AbstractScatterWinProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractScatterWinProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { GameFontStyle } from "../style/GameFontStyle";
export class GameScatterWinProperties extends AbstractScatterWinProperties {
    constructor() {
        super(...arguments);
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, false);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.counterTimes = [
            0,
            0,
            3,
            4,
            5
        ];
        this.character = new SpineProperties("Character", Modules.GAME);
        this.scale.set(1);
        this.title0Properties = new TextFieldProperties(GameFontStyle.SCATTER_WIN_ANIMATION_TITLE, new Point(0, -200), SlingoLang.JOKER_BONUS, ControlConstants.CENTER, ControlConstants.CENTER, new Point(400, 400));
        this.title0Properties.setMultiline(true);
        this.counterProperties = new TextFieldProperties(GameFontStyle.SCATTER_WIN_ANIMATION_COUNTER, new Point(0, 70), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(500, 140));
        this.titlePosition = new Point(0, 0);
    }
}
//# sourceMappingURL=GameScatterWinProperties.js.map